import { useState } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./DirectoryPopupFooter.module.scss";

interface IDirectoryFooterProps {
    isValid?: boolean;
    onCancel: () => void;
    onSave?: () => Promise<void>;
    disableInvalidateButton?: boolean;
    onInvalidate?: () => void;
    onModify?: () => void;
    onUseInstead?: () => void;
    cancelLabel?: string;
}

export function DirectoryPopupFooter(props: IDirectoryFooterProps): JSX.Element {
    const { getText } = useTranslation();

    const [isSaving, setIsSaving] = useState<boolean>(false);

    return (
        <div className={styles.footer}>
            <button
                className="btn btn-default"
                onClick={() => props.onCancel()}
            >
                {getText(props.cancelLabel ?? "CancelLabel")}
            </button>
            {props.onInvalidate && (
                <button
                    className="btn btn-danger"
                    onClick={() => props.onInvalidate()}
                    disabled={props.disableInvalidateButton || isSaving}
                >
                    {getText("DirectoryDeleteLabel")}
                </button>
            )}
            {props.onSave && (
                <button
                    className="btn btn-primary"
                    disabled={!props.isValid || isSaving}
                    onClick={async () => {
                        setIsSaving(true);
                        await props.onSave();
                        setIsSaving(false);
                    }}
                >
                    {getText("SaveLabel")}
                </button>
            )}
            {props.onModify && (
                <button
                    className="btn btn-primary"
                    disabled={!props.isValid}
                    onClick={() => props.onModify()}
                >
                    {getText("ModifyLabel")}
                </button>
            )}
            {props.onUseInstead && (
                <button
                    className="btn btn-primary"
                    disabled={!props.isValid}
                    onClick={() => props.onUseInstead()}
                >
                    {getText("UseLabel")}
                </button>
            )}
        </div>
    );
}
